<section>
  <div *ngIf="user_id != null" class="loged-container">
    <p>loged</p>
  </div>
  <div *ngIf="user_id == null" class="not-loged-container">
    <p>not loged</p>
  </div>
</section>
